// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-communication-container {
  padding: 35px;
  background-color: #fff;
}
@media (max-width: 768px) {
  .chat-communication-container {
    padding: 10px 35px;
    background-color: #fff;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/chat-communication/ChatCommunication.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF","sourcesContent":[".chat-communication-container {\n  padding: 35px;\n  background-color: #fff;\n}\n@media (max-width: 768px) {\n  .chat-communication-container {\n    padding: 10px 35px;\n    background-color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
